import { AppBackgroundController } from '@/components/AppBackgroundController';
import { ErrorBoundaryWrapper } from '@/components/ErrorBoundary/types';
import { FirebaseAuthChangeListener } from '@/features/auth';
import { NativeBridgeClient } from '@/features/nativeBridge';
import { HistoryNexus } from '@/features/routing';
import { LoggerClient } from '@/lib/Logger';
import { UserDataProvider } from '@/lib/userData/UserDataProvider';
import { detectPlatform } from '../lib/platform/detectPlatform';
import { MarketingPage } from './MarketingPage';
import { Layout } from './layout';
import { Routes } from './routes';
import '@/theme/globals.css';

// const inter = Inter({
//   variable: '--font-inter',
//   subsets: ['latin'],
//   // preload: false,
// });

// export const metadata: Metadata = {
//   title: 'Patchooli',
//   description: 'Patchooli is an app for tracking your mood and your mood history.',
//   other: {
//     'commit-hash': process.env.NEXT_PUBLIC_COMMIT_HASH ?? 'unknown',
//     'app-version': process.env.NEXT_PUBLIC_COMMIT_VERSION ?? 'unknown',
//   },
// };

// export const viewport: Viewport = {
//   themeColor: [
//     { media: '(prefers-color-scheme: light)', color: '#c6dee4' },
//     { media: '(prefers-color-scheme: dark)', color: '#c6dee4' },
//   ],
// };

export const App = () => {
  //   // Get bg-variant from headers
  //   const headersList = await headers();
  //   const bgVariant = headersList.get('x-bg-variant') === 'secondary' ? 'secondary' : 'primary';

  const platformData = detectPlatform();
  //   const userData = await getCurrentUser();
  // const platformData = {
  //   isMobileApp: false,
  //   isMarketingPage: false,
  //   userAgent: null,
  //   xClient: null,
  // };

  // cosn

  if (platformData.isMarketingPage) {
    return <MarketingPage />;
  }

  return (
    // The router base is required to make all other routes absolute from here.
    <ErrorBoundaryWrapper>
      <HistoryNexus>
        <UserDataProvider>
          <FirebaseAuthChangeListener />
          <NativeBridgeClient />
          <LoggerClient />
          <AppBackgroundController />

          <Layout>
            {/* The Routes component is the root of the app. It is used to navigate between pages. */}
            <Routes />
          </Layout>
        </UserDataProvider>
      </HistoryNexus>
    </ErrorBoundaryWrapper>
  );
};

// const PoppyRegister = () => {
//   useEffect(() => {
//     const onPopState = () => {
//       console.log(`%con popstate`, 'background:orange;');
//     };
//     window.addEventListener('popstate', onPopState);
//     return () => {
//       window.removeEventListener('popstate', onPopState);
//     };
//   }, []);
//   return null;
// };
